/* eslint-disable */
// configureStore.js
import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import userReducer from "./user/user";
import ProductsReducer from "./products/products";
import StoreReducer from "./store/store";
import AccountReducer from "./account/account";
import workerReducer from './worker/worker';
// import Worker from "./workers/workers";
import NotificationReducer from "./notification/notification";
import OrdersReducer from "./orders/orders";
import TransactionReducer from "./transaction/transaction";
import affiliateReducer from "./affiliate/affiliate";
import digitalStoreReducer from "./digitalStore/digitalStore";
import crossSellReducer from "./crossSell/crossSell";
import workersReducer from './workers/workers';
import cashbackReducer from "./cashback/cashback";
import orderStatsReducer from "./orderStats/orderStats";

// Combine all reducers
const reducer = combineReducers({
  userReducer,
  ProductsReducer,
  StoreReducer,
  AccountReducer,
  workerReducer, 
  OrdersReducer,
  TransactionReducer,
  affiliate: affiliateReducer,
  crossSell: crossSellReducer,
  cashbackReducer,
  NotificationReducer,
  digitalStoreReducer,
  workersReducer,
  orderStats: orderStatsReducer,
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
